import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subscribeBoxB",
  "use": "subscribeBoxB-usage",
  "viewBox": "0 0 942.2 443.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 942.2 443.3\" id=\"subscribeBoxB\">\n\t<path d=\"M307.6 364.5C108.8 422.1.6 349.5 0 262 4.3 143.5 118 77 211.4 48.8c155-46.8 376.5-59 439.6 53 51.8 91.8-144.6 205.1-343.4 262.7z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol